<template>
    <AppDialog :model-value="props.modelValue" @update:model-value="emit('update:modelValue', $event)">
        <form class="p-4 space-y-3" @submit.prevent="submit">
            <h3 class="text-center font-semibold">{{ t('scanner.manualTitle') }}</h3>
            <AppTextField ref="inputRef" v-model="code" />
            <AppButton type="submit" variant="success" large block :disabled="!code.length">OK</AppButton>
        </form>
    </AppDialog>
</template>

<script setup lang="ts">
    import { ref, watch } from 'vue'
    import { useI18n } from 'vue-i18n'
    import AppDialog from '@/components/ui/AppDialog.vue'
    import AppButton from '@/components/ui/AppButton.vue'
    import AppTextField from '@/components/ui/AppTextField.vue'

    const props = defineProps<{ modelValue: boolean }>()
    const emit = defineEmits<{
        'update:modelValue': [value: boolean]
        submit: [code: string]
    }>()

    const { t } = useI18n()
    const code = ref('')
    const inputRef = ref<InstanceType<typeof AppTextField> | null>(null)

    watch(
        () => props.modelValue,
        open => {
            if (open) {
                code.value = ''
                window.setTimeout(() => inputRef.value?.focus(), 200)
            }
        }
    )

    function submit() {
        if (!code.value.length) return
        emit('submit', code.value)
        emit('update:modelValue', false)
    }
</script>
